import { BrowserStorage } from '@estee/elc-universal-utils';
import { events } from '@estee/elc-service-bus';

const USER_CART_COOKIE = 'FE_USER_CART';

export function getCartItemCount(): number | null {
    const userCartCookie = BrowserStorage.getCookie(USER_CART_COOKIE) ?? '';

    if (!userCartCookie) {
        return null;
    }

    const decodedCookie = decodeURIComponent(userCartCookie || '');
    const formattedCookie = decodedCookie.replace(/:/g, '=');
    const cookieParams = new URLSearchParams(formattedCookie);
    const { item_count } = Object.fromEntries(cookieParams.entries()) || {};

    return item_count ? parseInt(item_count, 10) : null;
}

export function updateCartEvent(): void {
    const cartItemCount = getCartItemCount();

    if (cartItemCount !== null) {
        // cart.updated event dispatches multiple events for both legacy 2.0 and vulcan 3.0 cart drawers
        // itemQty property is used to update the cart drawer count in Vulcan bag icon
        // newState property is used to control the legacy cart drawer open state
        document.dispatchEvent(
            new CustomEvent(events.CART_UPDATED, {
                detail: {
                    itemQty: cartItemCount,
                    newState: false // Do not automatically open the cart drawer
                }
            })
        );

        // fetchCartDrawer dispatches vulcan 3.0 cart event to update cart drawer data
        window.dispatchEvent(
            new CustomEvent('fetchCartDrawer', {})
        );
    }
}
